

import Formulario from "../componentes/Formulario_padrao";

export default function AddTask(){



   
   return <>
          <Formulario textoBotao="Adicionar" tituloFormulario="Adicionar Tarefa" />
          </>


}

